__turbopack_context__.v({
  "Alpha": "AlphaControl-module-scss-module__Wfmqsq__Alpha",
});
